// 6. HOME PAGE
const HOME_PAGE_TEXT = {
    PAGE_TITLE: "SPA Template Title",
    PAGE_DESCRIPTION: "Select an operation",
    MAIN_BTN_LABEL_NEW_PROCESS: "Primary Button 1",
    MAIN_BTN_LABEL_MANAGEMENT_FILE: "Cards Page",
    MAIN_BTN_LABEL_PAPERWORKS_HISTORY: "Primary Button 3",
};

// 6.1. Nuova Lavorazione
const NEW_PROCESS_PAGE_TEXT = {
    PAGE_TITLE: "Title",
    PAGE_DESCRIPTION: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.", // TODO: The description is WIP
    FORM_INSTANCE_FORMAT: "Radio button",
    FORM_PAPERWORK_TYPE: "Select",
    FORM_LICENSE_PLATE: "Input",
    FORM_LICENSE_PLATE_PLACEHOLDER: "Insert field",
};

const ACTION_BAR_BUTTONS_TEXT = {
    EXIT: "Exit",
    CANCEL: "Cancel",
    RESET: "Reset",
    CONFIRM: "Confirm",
    TO_BACK: "Back",
    SEND: "Send"
};

const COMPONENTS_TEXT = {
    DROPDOWN_COMPONENT_PLEASE_CHOOSE_ONE_OPTION: "Please choose one option",
    SELECT_COMPONENT_NO_DATA_AVAILABLE: "No data available",
    SELECT_COMPONENT_LOADING: "Loading...",
    SELECT_COMPONENT_ERROR: "Error",
    SUCCESS_MSG: "EN_Operazione eseguita correttamente",
};

const LAYOUT_TEXT = {
    LOGO_LABEL: "SPA Template Title",
    ROUTE_LBL_HOME: "Home",
    ROUTE_LBL_NEW_PROCESS: "Menu",
    ROUTE_LBL_DIRECTORY_MANAGEMENT: "Gestione Fascicoli",
    ROUTE_LBL_PAPERWORKS_HISTORY: "Storico Pratiche",
    ROUTE_LBL_CONSULTATION: "Consultazioni",
    ROUTE_LBL_SEARCH_INSTANCE: "Side button",
    ROUTE_LBL_END_OF_DAY: "Side button",
    ROUTE_LBL_CERTIFICATION: "Side button",
    ROUTE_LBL_PAYMENT_CONSULTATION: "Side button",
    FOOTER_ROUTE_LBL_PRIVACY_POLICY: "Privacy Policy",
    FOOTER_ROUTE_LBL_LEGAL_NOTICES: "Note Legali",
    FOOTER_ROUTE_LBL_MEDIA_POLICY: "Media Policy",
    FOOTER_ROUTE_LBL_CONTACTS: "Contatti",
    FOOTER_ROUTE_LBL_ACCESSIBILITY: "Accessibilità",
    FOOTER_ROUTE_LBL_ASSISTANCE: "Assistenza",
};


const MESSAGE_VALIDATION_FIELD = {
    REQUIRED: "The field is required",
    MINLENGTH: "Insert the minimum lunge",
    MIN: "Insert a value valid",
    MAX: "Insert a value valid"
  };

  const CARD_LABEL = {
    HIDDEN: "Hidden",
    LOCKED: "Locked",
    ACTIVE: "Active",
    ERROR: "Error",
    COMPLETED: "Completed",
    WARNING: "Presentation in progress",
};

export {
    HOME_PAGE_TEXT,
    NEW_PROCESS_PAGE_TEXT,
    ACTION_BAR_BUTTONS_TEXT,
    COMPONENTS_TEXT,
    LAYOUT_TEXT,
    MESSAGE_VALIDATION_FIELD,
    CARD_LABEL
};
